/* eslint-disable */ 
import React, {useEffect, useState} from 'react';
import './components.css';
import Workout from './Workout';
import NewWorkoutButton from './NewWorkoutButton';
import { useStateValue } from '../ContextApi/StateProvider';
import { Redirect } from 'react-router-dom';

const Home = () => {
    const [initialState, dispatch] = useStateValue();
    const [workouts, setWorkouts] = useState([]);
    const authUser = JSON.parse(initialState.authenticatedUser);
    const indexArr = workouts.map(workout => {
        return <Workout
                    key={workout.id}
                    id={workout.id}
                    title={workout.title}
                    time={workout.time}
                />
    })
    useEffect(async() => {
        await initialState.WorkoutRequests.getWorkouts(authUser.emailAddress, authUser.password).then(
            response => setWorkouts(response),
            dispatch({
                type:"SET_WORKOUTS",
                workouts: workouts
            })
        ).catch(err => {
            console.log('Error' + err);
        })
    }, [])
    
    return ( 
        authUser ? (
            <div className="container-2025 section-2025">
                <NewWorkoutButton tabIndex={1}/>
                <div className="workout-list sm:mt-2">{indexArr}</div>
            </div>
        ) : (
            <Redirect to="/sign-in" />
        )
    )
}

export default Home